import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    display: 'block',
    width: 34,
    height: 34,
    objectFit: 'contain',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.logo}
      src="/aranox-brand/aranox-preto.png"
      alt="ARANOX"
    />
  );
};
